"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var isNumber = function isNumber(value) {
  return typeof value === 'number';
};

var _default = isNumber;
exports["default"] = _default;